import { v4 as uuidv4 } from 'uuid';
import { removeScheduleAPI } from './api';
import { getStore } from '../../factory';

export async function deleteSchedule(subscription, schedule) {
    const session = this.env.session;
    const traceId = this.env.traceId;

    this.env.startLoadCounter({ target: 'appProgress' });
    this.loadingList[schedule.scheduleId] = true;
    this.observed.loadingList = uuidv4();

    const res = await removeScheduleAPI({
        body: { calendarIds: [schedule.scheduleId] },
        store: this,
        token: session.token,
        traceId,
        subscriptionId: subscription.id,
    });

    this.env.stopLoadCounter();
    delete this.loadingList[schedule.scheduleId];
    this.observed.loadingList = uuidv4();

    if (res?.error) return;

    const subscriptionsStore = getStore('subscriptions');

    // Remove schedule from connected locally (no full API reload)
    const existing = subscriptionsStore.connectedSchedules[subscription.id] || [];
    subscriptionsStore.connectedSchedules = {
        ...subscriptionsStore.connectedSchedules,
        [subscription.id]: existing.filter(
            (s) => s.scheduleId !== schedule.scheduleId && s.id !== schedule.scheduleId
        ),
    };

    // Clear available so getAvailableSchedules replaces rather than appends
    subscriptionsStore.availableSchedules = {
        ...subscriptionsStore.availableSchedules,
        [subscription.id]: [],
    };

    // Refresh only this card's available schedules from backend
    await subscriptionsStore.getAvailableSchedules(subscription.id);

    this.deleteList.push(schedule);
    this.observed.deleteList = uuidv4();
}

export function removeItemFromDeletelist() {
    this.deleteList.pop();
}
